import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { ValidatedTextArea } from '../../../components/ValidatedTextArea';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { EnableFor } from '../../../containers/EnableForRole';
import { InputStatus } from '../../../models/error.model';
import { DatasetDetails } from '../DatasetDetails.context';
import { useDatasetPermissions } from '../datasets.permissions';

interface IProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onNameBlur: () => Promise<void>;
  onDescriptionBlur: () => Promise<void>;
  nameMaxLength: number;
  nameStatus: InputStatus;
  descriptionMaxLength: number;
  descriptionStatus: InputStatus;
  onAuthorBlur: (value: string) => Promise<void>;
  onTermsOfUseBlur: (value: string) => Promise<void>;
  authorStatus?: InputStatus;
  termsOfUseStatus?: InputStatus;
  onAuthorChange: (value: string) => void;
  onTermsOfUseChange: (value: string) => void;
  author: string;
  termsOfUse?: string;
}

export const DatasetEditablePageHeader = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const datasetsPermissions = useDatasetPermissions();
  const context = useContext(DatasetDetails);

  const canEditDetails = datasetsPermissions.canEditDatasetDetails(context.store.details.status, context.store.details.createdById);

  return (
    <>
      <EnableFor hasPermission={canEditDetails}>
        <ValidatedTextInput
          type={'text'}
          maxLength={props.nameMaxLength}
          value={props.name}
          onChange={props.onNameChange}
          onBlur={() => {
            void props.onNameBlur();
          }}
          isValid={props.nameStatus.isValid}
          feedbacks={props.nameStatus.errorCodes}
          placeholder={t('type_dataset_name')}
        />
        <ValidatedTextArea
          maxLength={props.descriptionMaxLength}
          value={props.description}
          onChange={props.onDescriptionChange}
          onBlur={() => {
            void props.onDescriptionBlur();
          }}
          isValid={props.descriptionStatus.isValid}
          feedbacks={props.descriptionStatus.errorCodes}
          placeholder={t('type_dataset_description')}
        />
        <ValidatedTextArea
          maxLength={props.descriptionMaxLength}
          value={props.author}
          onChange={props.onAuthorChange}
          onBlur={(val) => {
            void props.onAuthorBlur(val);
          }}
          isValid={props.authorStatus?.isValid}
          feedbacks={props.authorStatus?.errorCodes}
          placeholder={t('type_dataset_author')}
        />
        <ValidatedTextArea
          maxLength={props.descriptionMaxLength}
          value={props.termsOfUse}
          onChange={props.onTermsOfUseChange}
          onBlur={(val) => {
            void props.onTermsOfUseBlur(val);
          }}
          isValid={props.termsOfUseStatus?.isValid}
          feedbacks={props.termsOfUseStatus?.errorCodes}
          placeholder={t('type_dataset_terms_of_use')}
        />
      </EnableFor>
    </>
  );
});
